export default "__VITE_ASSET__Dui$sWkd__"